export const IMAGERY_VIEW = {
  favorite: 'Favourite',
  isShared: 'Shared',
  jobNumber: 'Job Number',
  name: 'Name',
  description: 'Description',
  organizationName: 'Organization',
  createdAt: 'Creation Date',
  productCount: 'Product Count',
  states: 'Status',
  Actions: '',
} as const;

export const POST_VIEW = {
  favorite: 'Favourite',
  isShared: 'Shared',
  jobNumber: 'Job Number',
  name: 'Name',
  description: 'Description',
  createdAt: 'Creation Date',
  productCount: 'Product Count',
  states: 'Status',
  Actions: '',
} as const;

export const CLIENT_VIEW = {
  favorite: 'Favourite',
  jobNumber: 'Job Number',
  name: 'Name',
  description: 'Description',
  createdAt: 'Start Date',
  productCount: 'SKU Count',
  status: 'Status',
  Actions: '',
} as const;

export type ViewConfig = typeof IMAGERY_VIEW | typeof POST_VIEW | typeof CLIENT_VIEW;
